import logo from './logo.svg'
import icon from './assets/icon-only.png'
import splash from './assets/splash.png'
import strings from './strings.json'
import stringsEn from './strings.en.json'
import meta from './meta.json'

// UniSR: static brand (from unisr.it), it always wins over the tenant customizations.
const config = {
  name: 'Università Vita-Salute San Raffaele',
  appName: meta.title,
  logo,
  icon,
  splash,
  splashColor: '#003D76',
  theme: {
    text: { color: '#333333' },
    link: { color: '#003D76' },
    h1: { color: '#333333' },
    h2: { color: '#333333' },
    h3: { color: '#333333' },
    primary_button: {
      background_color: '#003D76',
      text: { color: '#FFFFFF' },
      border: { color: '#003D76', depth: '2' },
      corner_radius: '4',
    },
    secondary_button: {
      background_color: '#FFFFFF',
      text: { color: '#333333' },
      border: { color: '#E6E6E6', depth: '3' },
      corner_radius: '4',
    },
    background: { type: 'colored', color: '#FFFFFF' },
  },
  strings: { it: strings, en: stringsEn },
  // Poppins for titles, links and buttons, Roboto for text (see brand.css)
  fontsUrl: 'https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;600;700&family=Roboto:wght@300;400;500;700&display=swap',
  loginIntro: true,
  supportByTf: false, // temporarily off: no thefaculty reference in the contact section
  tfAppSignup: false,
}

export default config
